export const MOCK_LIVE_EVENT_ID = 1001;
const DEFAULT_TITLE = 'CRM Workshop 1: How to Setup and Use Your HubSpot Account';
const DEFAULT_DESCRIPTION = "Join our 30-minute live session to learn how Academy Onboarding works, explore your resources, register for bootcamps, and get your questions answered. You'll leave with a clear plan and know exactly what to do next.";
export const createAssignment = ({
  attended = false,
  id,
  joinLink,
  sessionId,
  status = 'registered'
}) => ({
  id,
  userId: 1,
  sessionId,
  status,
  attended,
  joinLink: joinLink !== null && joinLink !== void 0 ? joinLink : '',
  zoomRegistrantId: `mock-registrant-${id}`
});
const TEST_SCENARIOS = {
  liveRegistered: {
    assignments: [createAssignment({
      id: 3100,
      joinLink: 'https://zoom.us/w/live-join',
      sessionId: 2100
    })]
  },
  liveUnregistered: {
    assignments: []
  },
  upcomingRegistered: {
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    })]
  },
  pastAttended: {
    assignments: [createAssignment({
      attended: true,
      id: 3200,
      sessionId: 2200
    })]
  },
  pastRegistered: {
    assignments: [createAssignment({
      id: 3200,
      sessionId: 2200
    })]
  },
  noAlert: {
    assignments: []
  },
  nextStepOneRegistered: {
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    })]
  },
  nextStepAllRegistered: {
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    }), createAssignment({
      id: 3010,
      sessionId: 2010
    }), createAssignment({
      id: 3011,
      sessionId: 2011
    })]
  },
  nextStepTwoRegistered: {
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    }), createAssignment({
      id: 3010,
      sessionId: 2010
    })]
  },
  nextStepCancelledAssignment: {
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001,
      status: 'cancelled'
    })]
  },
  nextStepMultipleSessionsSameEvent: {
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    }), createAssignment({
      id: 3002,
      sessionId: 2002
    })]
  }
};
const DEFAULT_SCENARIO = {
  assignments: []
};
const getTestScenario = () => {
  const testParam = new URLSearchParams(window.location.search).get('test');
  if (testParam && testParam in TEST_SCENARIOS) {
    return TEST_SCENARIOS[testParam];
  }
  return DEFAULT_SCENARIO;
};
export const MOCK_LIVE_EVENTS_LIST = [{
  id: MOCK_LIVE_EVENT_ID,
  title: 'CRM Workshop 2: How to Setup and Use Your HubSpot Account',
  internalName: 'crm-workshop-1002',
  description: DEFAULT_DESCRIPTION,
  type: 'workshop',
  instructors: ['1'],
  language: 'EN',
  previewThumbnailRectangleUrl: 'https://885765335.fs1.hubspotusercontentqa-na1.net/hubfs/885765335/rectangle-Arabian-dromedary-camel.webp'
}, {
  id: 1002,
  title: 'CRM Workshop 3: How to Setup and Use Your HubSpot Account',
  internalName: 'crm-workshop-1003',
  description: DEFAULT_DESCRIPTION,
  type: 'workshop',
  instructors: ['1'],
  language: 'EN',
  previewThumbnailRectangleUrl: 'https://885765335.fs1.hubspotusercontentqa-na1.net/hubfs/885765335/rectangle-Arabian-dromedary-camel.webp'
}, {
  id: 1003,
  title: DEFAULT_TITLE,
  internalName: 'crm-workshop-1001',
  description: DEFAULT_DESCRIPTION,
  type: 'workshop',
  instructors: ['1'],
  language: 'EN',
  previewThumbnailRectangleUrl: 'https://885765335.fs1.hubspotusercontentqa-na1.net/hubfs/885765335/rectangle-Arabian-dromedary-camel.webp'
}];
export const getMockFullLiveEvent = __liveEventId => {
  return {
    assignments: getTestScenario().assignments
  };
};